/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';
import type { PrefetchDictEntryType } from '../../types.tsx';
import { LOADING_PRIORITY } from './constant.tsx';
import { getActivityStreamPrefetchLink } from './prefetch-gadgets/activity-stream.tsx';
import { getFilterResultsPrefetchLink } from './prefetch-gadgets/filter-results.tsx';

export const getPrefetchDict = (): PrefetchDictEntryType => ({
	'jira-dashboard-items/activitystream': {
		func: getActivityStreamPrefetchLink,
		priority: LOADING_PRIORITY.HIGH,
		enabled: true,
		isSyncLoadingSupported: () => false,
	},

	'jira-dashboard-items/filter-results': {
		func: getFilterResultsPrefetchLink,
		priority: LOADING_PRIORITY.LOW,
		enabled: !expVal<boolean>('endeavour_nin_filter_results_gadget_config', 'value', false),
		isSyncLoadingSupported: () => true,
	},
});
